import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import "./SidePanel.scss";
import Button from "./Button";
import Spinner from "./Spinner";

function SidePanel(props) {
  // when enable mask is false then background mask lifted or removed .
  const {
    children,
    title,
    onClose,
    contentPaneStyles,
    enableMask = true,
    style,
    isMouseOutClose = true,
    vAlign = "panelRight",
    isBackgroundDisable = false,
    className = "sidePanel",
    customButton,
    customHeight = "100%",
    containerCSS = null,
    loader = false,
    showTitleOnHover = false, // This will shows the side panel title on hover
    customBtnSectionHeight = "",
  } = props;
  const sidePanelRef = useRef();
  const [SidePanelTitle, setSidePanelTitle] = useState(title);

  useEffect(() => {
    if (title) {
      setSidePanelTitle(title);
    }
  }, [title]);

  //Hide sidepanel when escape button is pressed.
  useEffect(() => {
      if (isMouseOutClose) {
          const listener = (e) => {
              if (e.keyCode === 27) {
                  onClose(e);
              }
              else if (!sidePanelRef.current.contains(e.target) && e.target.id !== "btnModelYes" && e.target.id !== "btnModelNo") {
                  onClose(e);
              }
          };
           document.addEventListener("keyup", listener);
           document.addEventListener("pointerdown", listener);
           return () => {
               document.removeEventListener("keyup", listener);
               document.removeEventListener("pointerdown", listener);
           };
      }
  }, [onClose]);

  const ChangeTitle = (newTitle) => {
    setSidePanelTitle(newTitle);
  };

  const childrenWithProps = React.Children.map(children, child => {
    // Checking isValidElement is the safe way and avoids a
    // typescript error too.
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { SidePanelProps: { ChangeTitle: ChangeTitle, SetWidth: (width) => { sidePanelRef.current.style.width = width; } } });
    }
    return child;
  });

  const defaultContainerCss = { height: customButton && !customBtnSectionHeight ? "90%" : customHeight, overflow: customButton ? "scroll" : "" };

  return createPortal(
    <div id={props.id}>
      <div
        className={enableMask ? "overlay" : undefined}
        style={isBackgroundDisable ? { background: "none", width: "auto" } : {}}
      />
      <div
        style={style}
        className={`sidepanel ${vAlign} ${className}`}
        ref={sidePanelRef}
      >
        <div className="sidepanel-header">
          <label title={showTitleOnHover && SidePanelTitle}>{SidePanelTitle}</label>
          <span
            id="sidePanelClose"
            className="sidepanel-close"
            onClick={onClose}
          />
        </div>

        <div className="sidepanel-content" style={contentPaneStyles}>
          <div
            className="sidepanel-container"
            style={containerCSS ? containerCSS : defaultContainerCss}
          >
            {loader ? <Spinner /> : childrenWithProps}
          </div>

          {customButton?.length && <TextButton customButton={customButton} customBtnSectionHeight={customBtnSectionHeight} />}
        </div>
      </div>
    </div>,
    document.querySelector("body")
  );
}

const TextButton = (props) => {
  const { customButton, customBtnSectionHeight } = props;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: customBtnSectionHeight || "10%",
      }}
    >
      {customButton.map((item,index) => (
        <Button
          key={index}
          type={item.type}
          label={item.label}
          onClick={item.buttonFunction}
          customStyle={item.customStyle}
          disabled={item.disabled}
        />
      ))}
    </div>
  );
};

export default SidePanel;
